/* BARROS — COLLECTION FACETS BEHAVIOR V2 */
(() => {
  'use strict';

  if (window.__barrosCollectionFacetsBehaviorReady) return;
  window.__barrosCollectionFacetsBehaviorReady = true;

  const ROOT = '#main-collection-filters';
  const DESKTOP_DETAILS = '#FacetsWrapperDesktop details.facets__disclosure';
  const desktop = window.matchMedia('(min-width: 750px)');

  function getRoot(node = document) {
    return node?.closest?.(ROOT) || document.querySelector(ROOT);
  }

  function facetIsActive(details) {
    if (!details) return false;
    if (details.querySelector('input[type="checkbox"]:checked')) return true;
    return Array.from(details.querySelectorAll('input[type="number"]')).some((input) => String(input.value || '').trim() !== '');
  }

  function closeFacets(root, except = null) {
    if (!root) return;
    root.querySelectorAll(`${DESKTOP_DETAILS}[open]`).forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  }

  function closeSort(root) {
    root?.querySelectorAll('.barros-sort__details[open]').forEach((details) => details.removeAttribute('open'));
  }

  function normalize(root = document.querySelector(ROOT)) {
    if (!root) return;

    root.querySelectorAll(DESKTOP_DETAILS).forEach((details) => {
      details.setAttribute('name', 'barros-collection-facets');
      const reset = details.querySelector('.facets__reset');
      if (reset) {
        if (reset.textContent.trim() !== 'Rimuovi filtro') reset.textContent = 'Rimuovi filtro';
        reset.hidden = !facetIsActive(details);
      }
    });

    root.querySelectorAll('.active-facets-desktop, .active-facets-mobile').forEach((group) => {
      const wrapper = group.querySelector('.active-facets__button-wrapper');
      const reset = wrapper?.querySelector('.active-facets__button-remove');
      if (!wrapper || !reset) return;
      const hasActive = group.querySelectorAll('a.active-facets__button').length > 0;

      /*
        barros-collection.js owns the underlying reset text for legacy/mobile
        normalization. Do not rewrite textContent here: two MutationObservers
        would otherwise keep changing the same node (Azzera/Rimuovi filtri).
        The Barros collection UI exposes the approved label through a stable
        data attribute and CSS pseudo-label instead.
      */
      reset.dataset.barrosResetLabel = 'Rimuovi filtri';
      reset.setAttribute('aria-label', 'Rimuovi filtri');
      wrapper.hidden = !hasActive;
    });

    if (desktop.matches) {
      const opened = Array.from(root.querySelectorAll(`${DESKTOP_DETAILS}[open]`));
      opened.slice(1).forEach((details) => details.removeAttribute('open'));
    }
  }

  function init() {
    const root = document.querySelector(ROOT);
    if (!root) return;

    if (desktop.matches) {
      closeFacets(root);
      closeSort(root);
    }
    normalize(root);

    const observer = new MutationObserver(() => requestAnimationFrame(() => normalize(document.querySelector(ROOT))));
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('toggle', (event) => {
    if (!desktop.matches) return;
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches(`${ROOT} ${DESKTOP_DETAILS}`) || !details.open) return;
    const root = getRoot(details);
    closeFacets(root, details);
    closeSort(root);
    normalize(root);
  }, true);

  document.addEventListener('click', (event) => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const root = document.querySelector(ROOT);
    if (!root) return;

    const sortTrigger = event.target.closest(`${ROOT} .barros-sort__trigger`);
    if (sortTrigger) {
      closeFacets(root);
      return;
    }

    if (!event.target.closest(`${ROOT} ${DESKTOP_DETAILS}`)) closeFacets(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !desktop.matches) return;
    const root = document.querySelector(ROOT);
    if (!root) return;
    const open = root.querySelector(`${DESKTOP_DETAILS}[open]`);
    const summary = open?.querySelector('summary');
    closeFacets(root);
    closeSort(root);
    summary?.focus?.({ preventScroll: true });
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(ROOT)) return;
    requestAnimationFrame(() => normalize(document.querySelector(ROOT)));
  });

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(init));
  desktop.addEventListener('change', () => requestAnimationFrame(() => {
    const root = document.querySelector(ROOT);
    if (!root) return;
    if (desktop.matches) closeFacets(root);
    normalize(root);
  }));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
